import {
    MDBCard,
    MDBCardBody,
    MDBCardHeader,
    MDBCardTitle,
} from "mdb-react-ui-kit";
import { InfoTooltip } from "../../../components";
import { ReportActionButtons } from "../../screened-manuscripts/components/ReportActionButtons";
import { ApplyAction } from "../../../components/ApplyAction";
import { dropdownOptions } from "../../screened-manuscripts/dropdownOptions";
import { CONDUCT_REASONS } from "stm-frontend-library";

export const renderField = (label, value) => {
  return value ? (
    <p>
      <strong>{label}:</strong> {value}
    </p>
  ) : null;
};

export const renderProvidedBy = (item) => {
    const value = (item?.provided_by_email ??  '') + ' ' + (item?.provided_by_publisher ??  '');

    return (value && value.trim()) && (
        <p>
            <strong>Provided by:</strong> {value}
        </p>
    );
};

const renderConductReasons = (item) => {
    const reasons = item?.conduct_reasons
        ?.map(value => CONDUCT_REASONS.find(r => r.value === value))
        .filter(Boolean) || [];

    return (
        <>
            <p>
                <strong>Conduct reasons:</strong>
            </p>
            {reasons.length > 0 ? (
                <div className='d-flex flex-column gap-2 mb-4'>
                    {reasons.map(reason => (
                        <MDBCard key={reason.value} className='border shadow-0'>
                            <MDBCardBody className='py-2 px-3'>
                                <strong>{reason.title}</strong>
                                {reason.description && (
                                    <p className='text-muted small mb-0 mt-1'>{reason.description}</p>
                                )}
                            </MDBCardBody>
                        </MDBCard>
                    ))}
                </div>
            ) : (
                <span className='mb-4'>—</span>
            )}
        </>
    );
};

export const renderBadActorsHitDetails = (item, index, array) => {
    return <div key={index}>
        {renderField("Hits", item?.totalHits)}
        {renderField("Fields", item?.match.join(', '))}
        {renderField("Name", item?.name)}
        {renderField("Email", item?.email)}
        {renderField("Orcid", item?.orcid)}
        {renderField("IPs", item?.ips)}
        {renderField("Institutions", item?.institutions)}
        {renderConductReasons(item)}
        {renderField("Timestamp", item?.created_at)}
        {renderProvidedBy(item)}
        {renderField("Comment", item?.comment)}
        {index < array.length - 1 && <hr className="hr"/>}
    </div>
};

export const renderBadActorsCardSection = (
  items,
  title,
  renderFunction,
  tooltipText = null,
  onActionSelect,
  onActionUndo,
  data
) => {
  if (items.length === 0) return null;

  const grouped = new Map();

  for (const item of items) {
    const existing = grouped.get(item.id);
    if (existing) {
      existing.match.add(item.match);
      existing.totalHits++;
    } else {
      grouped.set(item.id, { ...item, match: new Set([item.match]), totalHits: 1 });
    }
  }

  const groupedItems = Array.from(grouped.values()).map(item => ({
    ...item,
    match: Array.from(item.match),
    uniqueMatches: item.match.size,
  }));

  return (
    <MDBCard className="mt-3">
      <MDBCardHeader className="d-flex align-items-center">
        <ReportActionButtons signals={["conductCheck"]} iconOnly />
        <MDBCardTitle className="pt-2 ps-2">
          {title}
          {tooltipText && <InfoTooltip tooltipText={tooltipText} />}
        </MDBCardTitle>
        <div className="ms-auto">
          <ApplyAction
            index={data?.manuscript_id}
            status={data?.submission_status}
            selectAction={onActionSelect}
            undoAction={onActionUndo}
            options={dropdownOptions}
          />
        </div>
      </MDBCardHeader>
      <MDBCardBody>
        {groupedItems.map((item, index, array) => renderFunction(item, index, array))}
      </MDBCardBody>
    </MDBCard>
  );
};
